import getBillingModel, { BILLING_MODELS } from './getBillingModel';

// The live payment count covers charges only, so a page that sells subscriptions keeps
// the legacy product.chargeCount until a combined payments + subscriptions count exists.
export default function getCheckoutConversions(product, paymentCount: number) {
  return getBillingModel(product) === BILLING_MODELS.CHARGE ? paymentCount : product?.chargeCount;
}
